<template lang="pug">
	footer.footer
		.for-desktop
			.wrapper
				.table
					.tr
						.td
							router-link.logo(to="/")
								img.logo__img(src="@/assets/img/logo.svg")
						//- .td Хлібні крихти / Хлібні крихти
						.td
						.td
						.td
						.td
					.tr
						.td
							.footer__heading Про компанію
							.footer__link
								router-link(to='/about/') Компанія FMC
							.footer__link
								router-link(to='/news/') Новини
							.footer__link
								router-link(to='/promos/') Акції
							.footer__link
								router-link(to='/field-news/') Польові новини
							.footer__link
								router-link(to='/video/') Відео
						.td
							.footer__heading Продукти
							.footer__link(v-for="(card, i) in getProductsCatalogs" :key="i")
								router-link(:to="'/products/' + card.slug + '/'" v-text="card.name")
							//- .footer__link
							//- 	router-link(to='/products/insekticidi/') Інсектициди
							//- .footer__link
							//- 	router-link(to='/products/fungicidi/') Фунгіциди
							//- .footer__link
							//- 	router-link(to='/products/protrujniki/') Протруйники
							//- .footer__link
							//- 	router-link(to='/products/dopomizhni-rechovini/') Допоміжні речовини
						.td
							.footer__heading Захист рослин
							.footer__link
								router-link(to='/cultures/') Культури
							.footer__link
								router-link(to='/pests/') Шкідники
							.footer__link
								router-link(to='/weeds/') Бур’яни
							.footer__link
								router-link(to='/diseases/') Хвороби
						.td
							.footer__heading Контакти
							.footer__link(v-for="(card, index) in getRegions" :key="index")
								router-link(:to="'/contacts/' + card.slug + '/'" v-text="card.name")
							.footer__link
								//-router-link(to='/distributors/') Дистрибьютори
						.td
							.footer__heading Зворотній звязок
							.footer__link
								a(:href='"mailto:" + settings.contact_email' v-text="settings.contact_email")
							.footer__link
								a(href='tel:+38 (044) 364-82-58') +38 (044) 364-82-58
					.tr
						.td
							router-link(to="/terms-of-use/") Legal Notices & Terms of Use
						.td Created by <a href="https://www.fitel.io/" target="_blank">Fitel.io</a>
						.td
						.td
						.td
							.apps
								a.apps__item(v-if="settings.app_link_ios" :href="settings.app_link_ios" target="_blank" @click="sendAnalyticIos")
									img(src="@/assets/img/app1.svg")
								a.apps__item(v-if="settings.app_link_android" :href="settings.app_link_android" target="_blank" @click="sendAnalyticAndroid")
									img(src="@/assets/img/app2.svg")
		.for-mobile
			.wrapper
				router-link.logo(to="/")
					img.logo__img(src="@/assets/img/logo.svg")
				.items
					.item(:class="{'item_active': active === 0}")
						button.item__btn(@click="active = active === 0 ? -1 : 0") Про компанію
						slide-up-down(:active="active === 0" :duration="300")
							.item__dropdown
								router-link.item__link(to='/about/') Компанія FMC
								router-link.item__link(to='/news/') Новини
								router-link.item__link(to='/promos/') Акції
								router-link.item__link(to='/field-news/') Польові новини
								router-link.item__link(to='/video/') Відео
					.item(:class="{'item_active': active === 1}")
						button.item__btn(@click="active = active === 1 ? -1 : 1") Продукти
						slide-up-down(:active="active === 1" :duration="300")
							.item__dropdown
								router-link.item__link(v-for="(card, i) in getProductsCatalogs" :key="i" :to="'/products/' + card.slug + '/'" v-text="card.name") Гербіциди
					.item(:class="{'item_active': active === 2}")
						button.item__btn(@click="active = active === 2 ? -1 : 2") Захист рослин
						slide-up-down(:active="active === 2" :duration="300")
							.item__dropdown
								router-link.item__link(to='/cultures/') Культури
								router-link.item__link(to='/pests/') Шкідники
								router-link.item__link(to='/weeds/') Бур’яни
								router-link.item__link(to='/diseases/') Хвороби
					.item(:class="{'item_active': active === 3}")
						button.item__btn(@click="active = active === 3 ? -1 : 3") Контакти
						slide-up-down(:active="active === 3" :duration="300")
							.item__dropdown
								router-link.item__link(v-for="(card, index) in getRegions" :key="index" v-text="card.name" :to="'/contacts/' + card.slug + '/'")
								//-router-link.item__link(to='/distributors/') Дистрибьютори
					.item(:class="{'item_active': active === 4}")
						button.item__btn(@click="active = active === 4 ? -1 : 4") Зворотній звязок
						slide-up-down(:active="active === 4" :duration="300")
							.item__dropdown
								.footer__link
									a(:href='"mailto:" + settings.contact_email' v-text="settings.contact_email")
								.footer__link
									a(href='tel:+38 (044) 364-82-58') +38 (044) 364-82-58
				.footer__bottom
					router-link(to="/terms-of-use/") Legal Notices & Terms of Use
					.link Created by <a href="https://www.fitel.io/" target="_blank">Fitel.io</a>
					.apps
						a.apps__item(v-if="settings.app_link_ios" :href="settings.app_link_ios" target="_blank" @click="sendAnalyticIos")
							img(src="@/assets/img/app1.svg")
						a.apps__item(v-if="settings.app_link_android" :href="settings.app_link_android" target="_blank" @click="sendAnalyticAndroid")
							img(src="@/assets/img/app2.svg")
		.cookie(v-if="showCookie")
			button.cookie__close(@click="acceptCookie()")
			.cookie__text(v-html="settings.cookies_banner_content")
			button.cookie__btn(@click="acceptCookie()" v-html="settings.cookies_banner_button_text")

</template>

<script>

	let scriptAdded = false;

	import { mapState, mapGetters } from 'vuex';

	import SlideUpDown from 'vue-slide-up-down';

	export default {
		name: 'block-footer',
		data: function(){
			return {
				active: -1,
				showCookie: !this.$cookie.get('accept')
			}
		},
		methods: {
			acceptCookie() {
				this.showCookie = false;
				this.$cookie.set('accept', 'true', 180);
			},
          	sendAnalyticAndroid() {
            	dataLayer.push({
              		'eventCategory': 'application',
              		'eventAction': 'Click',
              		'eventLabel': 'app_android',
              		'event': 'app_android'
            	});
          	},
          	sendAnalyticIos() {
            	dataLayer.push({
              		'eventCategory': 'application',
              		'eventAction': 'Click',
              		'eventLabel': 'app_ios',
              		'event': 'app_ios'
            	});
          	},
		},
		created() {
			if (this.settings.isEmpty) this.$store.dispatch('GET_SETTINGS');

			if (!this.managers.length) this.$store.dispatch('GET_COLLECTION', 'managers');
			if (!this.regions.length) this.$store.dispatch('GET_COLLECTION', 'regions');

			if (!this.products.length) this.$store.dispatch('GET_COLLECTION', 'products');
			if (!this.newProducts.length) this.$store.dispatch('GET_NEW_PRODUCTS', 'newProducts');
			if (!this.catalogs.length) this.$store.dispatch('GET_COLLECTION', 'catalogs');
		},
		components: {
			'slide-up-down': SlideUpDown
		},
		mounted() {
			if (this.settings.google_analytics_id) {
				if (!scriptAdded) {
					var script = document.createElement('script');
					script.type = 'text/javascript';
					script.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.settings.google_analytics_id;

					document.getElementsByTagName('head')[0].appendChild(script);
					scriptAdded = true;
				}

				window.dataLayer = window.dataLayer || [];
				var gtag = function(){window.dataLayer.push(arguments);}
				gtag('js', new Date());

				gtag('config', this.settings.google_analytics_id);
			}
		},
		computed: {
			...mapState([
				'managers',
				'regions',
				'settings',
				'products',
				'newProducts',
				'catalogs'
			]),
			...mapGetters([
				'getRegions',
				'getManagersByRegion',
				'getProductsCatalogs'
			])
		},
		watch: {
			settings() {
				if (this.settings.google_analytics_id) {

					if (!scriptAdded) {
						var script = document.createElement('script');
						script.type = 'text/javascript';
						script.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.settings.google_analytics_id;

						document.getElementsByTagName('head')[0].appendChild(script);
						scriptAdded = true;
					}

					window.dataLayer = window.dataLayer || [];
					var gtag = function(){window.dataLayer.push(arguments);}
					gtag('js', new Date());

					gtag('config', this.settings.google_analytics_id);
				}
			}
		}
	}

</script>

<style lang="scss" scoped>

	.cookie {
		position: fixed;
		bottom: 0;
		z-index: 10;
		left: calc(50% - 640px);
		width: 1280px;
		background-color: #fff;
		padding: 17px 120px 54px 108px;

		&__close {
			position: absolute;
			top: 0;
			left: 100%;
			width: 24px;
			height: 24px;
			background: url('../../assets/img/close_white.svg') #EF3E33 no-repeat center center;
		}

		&__text {
			font: 14px/1.3 'Helvetica', Arial, sans-serif;
			letter-spacing: .7px;

      >>> p {
        line-height: 1.24;
      }

      >>> a {
        line-height: 1.24;
      }
		}

		&__btn {
			position: absolute;
			left: 108px;
			bottom: 20px;
			width: 122px;
			height: 30px;
			background: #EF3E33;
			color: #fff;
			font: 11px 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
			text-transform: uppercase;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
		}

    >>> a {
			text-decoration: underline;
		}
	}

	.for-desktop {
		display: block;
	}

	.for-mobile {
		display: none;
	}

	.footer {
		background-color: #fff;
		padding-top: 27px;

		&__link {
			display: block;
			line-height: 16px;
			font-size: 16px;
			font-weight: 300;
			margin-bottom: 14px;


			a {
				transition: opacity .5s ease;
				letter-spacing: 0.03em;
				line-height: 16px;
				font-size: 16px;
				font-weight: 300;

				@media screen and (min-width: 1201px) {

					&:hover {
						opacity: .7;
					}
				}
			}
		}

		&__heading {
			display: block;
			line-height: 17px;
			font-size: 17px;
			font-weight: 500;
			margin-bottom: 23px;
			letter-spacing: -0.01em;
		}
	}

	.table {
		display: table;
		table-layout: fixed;
		width: 100%;
	}

	.tr {
		display: table-row;

	}

	.td {
		display: table-cell;
		width: 20%;
		vertical-align: top;
	}

	.tr:nth-child(1) {
		.td {
			vertical-align: middle;
		}
	}

	.tr:nth-child(2) {
		.td {
			padding-top: 47px;
			padding-bottom: 53px;

			&:nth-child(2) {
				padding-left: 4px;

			}

			&:nth-child(3) {
				padding-left: 8px;

				.footer__link:nth-child(2) {
					a {
						letter-spacing: 0.1em;
					}
				}
			}

			&:nth-child(4) {
				padding-left: 12px;

			}

			&:nth-child(5) {
				padding-left: 16px;

				.footer__link {
					a {
						letter-spacing: 0.1em;
					}
				}
			}


		}
	}

	.tr.tr:nth-child(3) {
		.td {
			font: 300 14px/18px 'Helvetica', Arial, sans-serif;
			font-size: 16px;
			line-height: 16px;
			letter-spacing: 0.03em;

			&:nth-child(2) {
				padding-left: 5px;
			}
		}
	}

	.logo {
		display: inline-block;
		vertical-align: top;
	}

	.apps {
		font-size: 0;
		float: right;

		&__item {
			display: inline-block;
			vertical-align: top;
			transition: opacity .5s ease;

			img {
				width: 110px;
			}

			@media screen and (min-width: 1201px) {

				&:hover {
					opacity: .7;
				}
			}

			&:nth-child(2) {
				margin-left: 20px;
			}
		}
	}

	@media screen and (max-width: 1280px) {
		.cookie {
			max-width: 100%;
			width: 100%;
			left: 0;
			padding-left: 10%;
			padding-right: 10%;

			&__btn {
				left: 10%;
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.for-desktop {
			display: none;
		}

		.for-mobile {
			display: block;
		}

		.logo {
			width: auto;
			height: 20px;
			display: block;
			margin-bottom: 36px;

			&__img {
				width: auto;
				height: 100%;
			}
		}

		.item {
			display: block;
			border-top: 1px solid #F2F2F2;
			// padding: 20px;

			&__dropdown {
				// display: none;
				// margin-top: 10px;
				padding-top: 10px;
			}

			&__btn {
				font: 500 16px/1 'Helvetica', Arial, sans-serif;
				letter-spacing: .5px;
				padding: 20px;
				width: 100%;
				text-align: left;
				position: relative;

				& + div {
					will-change: height;
				}

				&:after {
					content: "";
					display: block;
					width: 56px;
					height: 56px;
					position: absolute;
					top: 0;
					right: 0;
					background: url('../../assets/img/plus.svg') no-repeat center center;
					transform: rotate(0);
					transition: transform .5s ease;
				}
			}

			&_active {
				.item__dropdown {
					// display: block;
				}

				.item__btn {
					&:after {
						transform: rotate(45deg);
					}
				}
			}

			&:last-child {
				border-bottom: 1px solid #F2F2F2;
			}

			&__link {
				display: block;
				margin-bottom: 30px;
				margin-bottom: 0;
				font-size: 16px;
				line-height: 16px;
				font-weight: 300;
				padding: 0 20px 30px;

				&:last-child {
					margin-bottom: 0;
					padding-bottom: 30px;
				}
			}
		}

		.footer {
			&__bottom {
				margin-top: 31px;
				padding: 0 20px 44px 0;
				font: 300 16px/1 'Helvetica', Arial, sans-serif;
				letter-spacing: .5px;

				.link {
					margin-top: 30px;
					padding: 0 20px;
				}

				> a {
					padding: 0 20px;
				}
			}

			&__link {
				padding: 0 20px;
				margin-bottom: 0;
				padding-bottom: 14px;
			}
		}

		.apps {
			// width: calc(100% + 40px);
			// margin-left: -20px;
			display: flex;
			justify-content: space-between;
			// margin-top: 50px;


			&__item {
				margin-right: 0;
				width: 158px;

				img {
					width: 100%;
					display: block;
				}

				&:nth-child(2) {
					img {
						// margin-top: 4px;
					}
				}
			}
		}
	}

	@media(max-width: 650px) {
		.footer__bottom {
			position: relative;
			padding: 0 20px 115px 0;

			> a {
				padding: 0 20px;
			}

			.link {
				padding: 0 20px;
			}
		}

		.apps {
			position: absolute;
			bottom: 30px;
			width: 100%;
			margin: 0 auto;
		}
	}
</style>
